import React from 'react';
import { Card, CardContent, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

// BA-147: static how-to-leave-pinned-mode card; no Firebase state, same text locked or not.
const DashLockCard: React.FC = () => {
  const { t } = useTranslation();
  return (
    <Card sx={{ mt: 2, borderLeft: 4, borderColor: '#6750A4' }}>
      <CardContent>
        <Typography variant="h6" gutterBottom>{t('dashLock.title')}</Typography>
        <Typography variant="body1" sx={{ mt: 1 }}>{t('dashLock.p1')}</Typography>
        <Typography variant="body1" sx={{ mt: 1 }}>{t('dashLock.p2')}</Typography>
        <Typography variant="body1" sx={{ mt: 1, color: '#4A3A8A', fontWeight: 500 }}>{t('dashLock.p3')}</Typography>
      </CardContent>
    </Card>
  );
};

export default DashLockCard;
